/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.14.0
 */

import { useDispatch, useSelector } from 'react-redux';

import { Button, LinkBlock } from '../../../../../components/common';
import { getErrorTranslation } from '../../../../../modules/internationalization/helpers/intGetErrorTrnaslation';
import { makeSelectTranslationCommon } from '../../../../../modules/internationalization/intSelectors';
import Modal from '../../../../../modules/modal/components/Modal';
import { modalCloseAll, modalSetStatusAction } from '../../../../../modules/modal/modalActions';
import { EModalStatus, IModalRenderProps } from '../../../../../modules/modal/types/modalTypes';
import ButtonServiceUserDenied from '../../../../../modules/role/components/ButtonServiceUserDenied';
import { manageNumberTranslationSelector } from '../selectors';
import { useRemoveManageNumberRedirectionMutation } from '../store';
import { IManageNumberRedirection } from '../types';


interface IModalRemove extends Pick<IModalRenderProps, 'onCloseModal'> {
    item: IManageNumberRedirection;
    subscriberId: string;
}

const ManageNumberRedirectionModalRemove = ({
                                                item,
                                                subscriberId,
                                                onCloseModal,
                                            }: IModalRemove) => {

    const dispatch = useDispatch();

    /* Select State */

    const translationCommon = useSelector(makeSelectTranslationCommon());
    const translationManageNumber = useSelector(manageNumberTranslationSelector());

    /* Api */

    const [removeRedirection, { error }] = useRemoveManageNumberRedirectionMutation();

    const onRemoveBtnClick = () => {
        dispatch(modalSetStatusAction({ status: EModalStatus.processing }));
        removeRedirection({ item, subscriberId })
            .unwrap()
            .then(() => {
                dispatch(modalCloseAll());
            })
            .catch(() => {
                dispatch(modalSetStatusAction({ status: EModalStatus.failure }));
            });
    };

    return (
        <Modal dataName="modal-remove" width="380px">
            <Modal.Status status={EModalStatus.start}>
                <Modal.Title>
                    {translationManageNumber.redirection.remove[EModalStatus.start].title}
                </Modal.Title>
                <Modal.Text>
                    {translationManageNumber.redirection.remove[EModalStatus.start].text}
                </Modal.Text>
                <Modal.Control>
                    <ButtonServiceUserDenied onClick={onRemoveBtnClick}>
                        {translationCommon.modal.remove}
                    </ButtonServiceUserDenied>
                    <LinkBlock onClick={onCloseModal}>
                        {translationCommon.modal.close}
                    </LinkBlock>
                </Modal.Control>
            </Modal.Status>

            <Modal.Status status={EModalStatus.failure}>
                <Modal.Title>
                    {translationManageNumber.redirection.remove[EModalStatus.failure].title}
                </Modal.Title>
                <Modal.Text>
                    {
                        getErrorTranslation(
                            error, translationCommon.error, translationManageNumber.redirection.error,
                        )
                    }
                </Modal.Text>
                <Modal.Control>
                    <Button onClick={onCloseModal}>{translationCommon.modal.close}</Button>
                </Modal.Control>
            </Modal.Status>
        </Modal>

    );
};

export default ManageNumberRedirectionModalRemove;
